import type { ComponentProps } from 'react';
import { TableToolbar as StrictTableToolbar } from './TableToolbar';

type StrictToolbarProps = ComponentProps<typeof StrictTableToolbar>;

type LegacyToolbarProps = StrictToolbarProps & {
  stale?: boolean;
  degraded?: boolean;
  onShowFilterRowChange?: (show: boolean) => void;
  rowActions?: unknown;
  pagination?: unknown;
  onPageSizeChange?: (size: number) => void;
  pageSizeOptions?: number[];
};

/**
 * Compatibility boundary for the historical TableRenderer call shape.
 * Deprecated renderer-only props are consumed here, while the strict toolbar
 * receives only its declared contract. This keeps migration explicit without
 * disabling prop type checking for the component.
 */
export function TableToolbar({
  stale: _stale,
  degraded: _degraded,
  onShowFilterRowChange: _onShowFilterRowChange,
  rowActions: _rowActions,
  pagination: _pagination,
  onPageSizeChange: _onPageSizeChange,
  pageSizeOptions: _pageSizeOptions,
  ...strictProps
}: LegacyToolbarProps) {
  return <StrictTableToolbar {...strictProps} />;
}
